<div class="activity page" *ngIf="stream">
  <div class="title">Recent Activity in {{ name }}</div>
  <div class="description">Shared catches, Fishing spots and Reports</div>
  <div class="content">
    <div class="item" *ngFor="let post of stream">
      <app-feed-post [post]="post" [translateJSON]="translateJSON"> </app-feed-post>
    </div>
  </div>
</div>